<template>

  <div class="sidebar-container">
    <div v-if="!editing">
      <h3>{{ $t('map.sidebar.search') }}</h3>

      <asset-autocomplete :value="value"
                          :clearable="true"
                          :label="$t('map.sidebar.search-asset')"
                          @input="assetChanged($event)"
      ></asset-autocomplete>

      <div v-if="filteredElements.length > 1">
        <v-alert outlined type="warning" icon="report_problem">
          {{ $t('map.sidebar.more-elements-assigned') }}
        </v-alert>

        <v-list>
          <v-list-item v-for="(item, index) in filteredElements" :key="index" @click="selectElement(item)">
            <v-list-item-avatar>
              <v-icon>{{ icons[item.type] }}</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Element {{ index + 1 }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon ripple>
                <v-icon color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>

      <v-alert outlined type="error" icon="report_problem" v-if="value && filteredElements.length === 0">
        {{ $t('map.sidebar.no-elements-found') }}
      </v-alert>

    </div>
  </div>

</template>

<style lang="scss" scoped>

</style>

<script>

import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AssetAutocomplete from '../../assets/asset-autocomplete.vue'

const mapModule = namespace('map')

@Component({
  components: {
    assetAutocomplete: AssetAutocomplete
  }
})
export default class SidebarSearch extends Vue {
  /// PROPERTIES

  value = null

  icons = {
    polygon: 'details',
    polyline: 'linear_scale',
    marker: 'place'
  }

  @mapModule.State('selected') selected

  @mapModule.State('elements') elements

  @mapModule.Getter('editing') editing

  @mapModule.Action('select') select

  /// GETTERS

  get asset () {
    if (this.selected) { return this.selected.assetId }

    return null
  }

  get filteredElements () {
    return this.elements.filter(element => this.value && element.assetId === this.value)
  }

  /// METHODS

  assetChanged (id) {
    this.value = id

    if (this.filteredElements.length === 1) {
      this.selectElement(this.filteredElements[0])
    }
  }

  @Emit('selected')
  selectElement (element) {
    this.select(element)

    return element
  }
}

</script>
